export default "__VITE_ASSET__DOMUu6ud__"